@if (issue) {
    <div class="connectivity-overlay">
        <div class="connectivity-overlay__card">
            @if (issue === 'offline') {
                <div class="connectivity-overlay__icon connectivity-overlay__icon--offline">
                    <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" fill="none"
                         stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
                        <line x1="1" y1="1" x2="23" y2="23"/>
                        <path d="M16.72 11.06A10.94 10.94 0 0 1 19 12.55"/>
                        <path d="M5 12.55a10.94 10.94 0 0 1 5.17-2.39"/>
                        <path d="M10.71 5.05A16 16 0 0 1 22.56 9"/>
                        <path d="M1.42 9a15.91 15.91 0 0 1 4.7-2.88"/>
                        <path d="M8.53 16.11a6 6 0 0 1 6.95 0"/>
                        <line x1="12" y1="20" x2="12.01" y2="20"/>
                    </svg>
                </div>
                <h2 class="connectivity-overlay__title">{{ 'General.InternetOffline' | i18next }}</h2>
                <p class="connectivity-overlay__message">{{ 'General.InternetOfflineMessage' | i18next }}</p>
            }

            @if (issue === 'clock-skew') {
                <div class="connectivity-overlay__icon connectivity-overlay__icon--clock">
                    <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" fill="none"
                         stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
                        <circle cx="12" cy="12" r="10"/>
                        <polyline points="12 6 12 12 16 14"/>
                    </svg>
                </div>
                <h2 class="connectivity-overlay__title">{{ 'General.ClockOutOfSync' | i18next }}</h2>
                <p class="connectivity-overlay__message">{{ 'General.ClockOutOfSyncMessage' | i18next }}</p>
                <button class="connectivity-overlay__retry" (click)="retry()">
                    {{ 'General.Retry' | i18next }}
                </button>
            }
        </div>
    </div>
}
